module.exports = '<svg width="32" height="32" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><path d="M3.24 26.116A2 2 0 0 0 5.032 29h21.933a2 2 0 0 0 1.781-2.91L17.588 4.234a2 2 0 0 0-3.575.026L3.24 26.116zM13.533.69a5 5 0 0 1 6.726 2.18L31.42 24.726A5 5 0 0 1 26.966 32H5.033A5 5 0 0 1 .55 24.79L11.322 2.931A5 5 0 0 1 13.534.69zM17.8 26v-2a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1zm0-5.929V8.93c0-.513-.448-.929-1-.929h-2c-.552 0-1 .416-1 .929V20.07c0 .513.448.929 1 .929h2c.552 0 1-.416 1-.929z" fill="#F39C5C" fill-rule="nonzero"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/exclamation-point-3.js
// module id = 1127
// module chunks = 14